export default __webpack_public_path__ + "static/media/Bionic-Arm-07.3e57f3bf.jpg";